var ko = require('knockout');
var $ = require('jquery');

ko.components.register('article-list', {
  viewModel: require('./article-list'),
  template: require('./article-list.template')
});

$('[data-article-list]').each(function() {
  ko.applyBindings({}, this);
});
